'use strict'

const SIGNUP_PROGRESS = {
  'Creating your account': 8,
  'Preparing storage': 18,
  'Starting the server': 40,
  'Assigning the address': 55,
  'Publishing the address': 70,
  'Waiting for the server to come online': 80,
  'Signing you in': 96
}

function signupStatus (status, progress) {

  const known = SIGNUP_PROGRESS[status]

  return {
    status,
    progress: progress == null ? known : progress
  }
}

function waitingProgress (fraction) {

  const start = SIGNUP_PROGRESS['Waiting for the server to come online']
  const bounded = Math.min(1, Math.max(0, fraction))

  return start + Math.round(bounded * (94 - start))
}

function signupEvent (event) {

  return `data: ${JSON.stringify(event)}\n\n`
}

function takeSignupEvents (buffer) {

  const parts = String(buffer || '').split('\n\n')
  const rest = parts.pop()
  const events = []

  parts.forEach((part) => {

    const line = part.split('\n').map((item) => item.trim()).find((item) => item.startsWith('data:'))

    if (!line) return

    events.push(JSON.parse(line.slice(line.indexOf(':') + 1).trim()))
  })

  return { events, rest }
}

function openSignupProgress (res) {

  res.status(200)
  res.set({
    'Content-Type': 'text/event-stream; charset=utf-8',
    'Cache-Control': 'no-cache, no-transform',
    Connection: 'keep-alive',
    'X-Accel-Buffering': 'no'
  })

  if (typeof res.flushHeaders === 'function') res.flushHeaders()

  return function send (event) {

    if (!res.writable) throw new Error('signup progress closed')

    res.write(signupEvent(event))

    if (typeof res.flush === 'function') res.flush()
  }
}

function clientWantsSignupProgress (req) {

  return String(req.headers.accept || '').indexOf('text/event-stream') !== -1
}

module.exports = {
  SIGNUP_PROGRESS,
  signupStatus,
  waitingProgress,
  signupEvent,
  takeSignupEvents,
  openSignupProgress,
  clientWantsSignupProgress
}
